/**
 * digitvision
 *
 * @category  digitvision
 * @package   Shopware\Plugins\DvsnFormBuilder
 * @copyright (c) 2026 digitvision
 */

import './component';
import './config';
import './preview';

Shopware.Service('cmsService').registerCmsElement({
    name: 'dvsn-form-builder',
    label: 'dvsn-form-builder.cms-element.label',
    component: 'sw-cms-el-dvsn-form-builder',
    configComponent: 'sw-cms-el-config-dvsn-form-builder',
    previewComponent: 'sw-cms-el-preview-dvsn-form-builder',
    defaultConfig: {
        form: {
            source: 'static',
            value: null
        }
    }
});
